export var isArray = function isArray(val) {
  return Object.prototype.toString.call(val) === '[object Array]';
};
export var isString = function isString(val) {
  return Object.prototype.toString.call(val) === '[object String]';
};
export var isObject = function isObject(val) {
  return Object.prototype.toString.call(val) === '[object Object]';
};
export var isNumber = function isNumber(val) {
  return Object.prototype.toString.call(val) === '[object Number]';
};
export var isCascader = function isCascader(_ref) {
  var dataSource = _ref.dataSource;
  return dataSource && dataSource[0] && !isArray(dataSource[0]);
};